import { PatientListPage } from '@/pages/Patient';
import { PATIENT_LIST_ORG_STORAGE_KEY } from '@/utils/organizationFilterStorage';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useLocalStorage } from 'usehooks-ts';
import { z } from 'zod';

const PatientSearchSchema = z.object({
  search: z.string().default(''),
  organizationId: z.string().min(1).optional(),
  pageIndex: z.number().int().min(0).default(0),
});

const RouteComponent = (): React.ReactNode => {
  // oxlint-disable-next-line no-use-before-define
  const { search, organizationId: urlOrganizationId, pageIndex } = Route.useSearch();
  // oxlint-disable-next-line no-use-before-define
  const navigate = useNavigate({ from: Route.fullPath });
  const [storedOrganizationId, setStoredOrganizationId] = useLocalStorage<string | undefined>(
    PATIENT_LIST_ORG_STORAGE_KEY,
    undefined,
  );

  // URL param wins (bookmarks/shared links); fall back to the sticky stored value.
  const organizationId = urlOrganizationId ?? storedOrganizationId;

  return (
    <PatientListPage
      search={search}
      setSearch={(search) => {
        void navigate({ search: (prev) => ({ ...prev, search, pageIndex: 0 }) });
      }}
      organizationId={organizationId}
      setOrganizationId={(organizationId) => {
        setStoredOrganizationId(organizationId);
        void navigate({ search: (prev) => ({ ...prev, organizationId, pageIndex: 0 }) });
      }}
      pageIndex={pageIndex}
      setPageIndex={(pageIndex) => {
        void navigate({ search: (prev) => ({ ...prev, pageIndex }), replace: true });
      }}
    />
  );
};

export const Route = createFileRoute('/_auth/patients/')({
  component: RouteComponent,
  validateSearch: PatientSearchSchema,
  loader: () => ({ crumb: 'Patients' }),
});
